var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", attrs: { loading: _vm.saveLoad } },
    [
      _c("div", { staticClass: "materialFormLine" }, [
        _vm._v("广宣物料信息修改"),
      ]),
      _c(
        "div",
        { staticClass: "budgetBox" },
        [
          _c(
            "a-form-model",
            {
              ref: "material",
              staticClass: "UniformCss form-container",
              attrs: {
                inline: true,
                model: _vm.material,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "物料号", prop: "materialCode" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.material.materialCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "materialCode", $$v)
                              },
                              expression: "material.materialCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "物料名称", prop: "materialName" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.material.materialName,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "materialName", $$v)
                              },
                              expression: "material.materialName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "物料类型", prop: "materialType" } },
                        [
                          _c(
                            "a-select",
                            {
                              model: {
                                value: _vm.material.materialType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.material, "materialType", $$v)
                                },
                                expression: "material.materialType",
                              },
                            },
                            _vm._l(
                              _vm.SelectLists.PromotionMaterialType,
                              function (item) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: item.code,
                                    attrs: { value: item.code },
                                  },
                                  [_vm._v(_vm._s(item.value))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "库存量", prop: "storage" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.material.storage,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "storage", $$v)
                              },
                              expression: "material.storage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "申领单价（元）", prop: "price" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "", type: "number" },
                            model: {
                              value: _vm.material.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "price", $$v)
                              },
                              expression: "material.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: "制作单价（元）", prop: "prodPrice" },
                        },
                        [
                          _c("a-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.material.prodPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "prodPrice", $$v)
                              },
                              expression: "material.prodPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "单位", prop: "unit" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.material.unit,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "unit", $$v)
                              },
                              expression: "material.unit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "安全库存",
                            prop: "storageSafetyValue",
                          },
                        },
                        [
                          _c("a-input-number", {
                            attrs: { min: 0, precision: 0 },
                            model: {
                              value: _vm.material.storageSafetyValue,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.material,
                                  "storageSafetyValue",
                                  $$v
                                )
                              },
                              expression: "material.storageSafetyValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("a-textarea", {
                            attrs: { rows: 1 },
                            model: {
                              value: _vm.material.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "remark", $$v)
                              },
                              expression: "material.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "物料图片" } },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticClass: "upload-demo",
                              attrs: {
                                accept: ".jpg,.png",
                                limit: 4,
                                action: "",
                                "list-type": "picture-card",
                                "on-preview": _vm.handlePreview,
                                "on-remove": _vm.handleRemove,
                                "on-change": _vm.onChangeImg,
                                "file-list": _vm.fileList,
                                multiple: "",
                                "auto-upload": false,
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip",
                                },
                                [
                                  _vm._v(
                                    "只能上传jpg/png文件，每张不超过2M，最多上传4张，照片名称不可重复"
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "a-modal",
                            {
                              attrs: { width: "40%", footer: null },
                              model: {
                                value: _vm.dialogVisible,
                                callback: function ($$v) {
                                  _vm.dialogVisible = $$v
                                },
                                expression: "dialogVisible",
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.dialogImageUrl,
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-container" },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.returnFun()
                    },
                  },
                },
                [_vm._v("返回")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit()
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }